import { render, staticRenderFns } from "./audio-block.vue?vue&type=template&id=38c14cab&scoped=true"
import script from "./audio-block.vue?vue&type=script&lang=ts"
export * from "./audio-block.vue?vue&type=script&lang=ts"
import style0 from "./audio-block.vue?vue&type=style&index=0&id=38c14cab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c14cab",
  null
  
)

export default component.exports